import { Box, HStack, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { SectionHeader } from '../common/SectionHeader';

type LeverageAndVolatilityProps = {
  children?: React.ReactNode;
};

export const LeverageAndVolatility: React.FC<LeverageAndVolatilityProps> = () => {
  const { property } = usePropertiesModel();

  const volatility = Number(property?.sfr?.volatility ?? 0);
  return (
    <VStack alignItems="flex-start">
      <SectionHeader text="Property Leverage and Volatility" />
      <HStack justifyContent={'space-between'} width="100%" position="relative" height="130px">
        <Box
          w="100%"
          background={`linear-gradient(-90deg, #FFA800 0%, #CDFF3D 100%)`}
          height="30px"
          position="absolute"></Box>
        <Box
          display="flex"
          flexDirection={'column'}
          width="60px"
          position="absolute"
          alignItems={'center'}
          top="0px"
          left={`calc(${volatility}% - 30px)`}
          justifyContent="center"
          style={{ margin: 0, padding: 0 }}>
          <TextBlock textAlign={'center'} fontSize="12px" weight="bold">
            {volatility}%
          </TextBlock>
          <Box style={{ transform: 'rotate(180deg)' }}>
            <Icon icon="triangle" boxSize={'16px'} />
          </Box>
          <Box
            borderLeft={`1px solid rgba(0,0,0,0.5)`}
            borderStyle="dashed"
            width="2px"
            height="40px"
            marginTop="4px"></Box>
        </Box>
        <TextBlock
          fontSize="12px"
          lineHeight={'30px'}
          position="absolute"
          left="0px"
          top="95px"
          textAlign={'left'}
          style={{ margin: 0, padding: 0 }}>
          Lower
        </TextBlock>
        <TextBlock
          fontSize="12px"
          lineHeight={'30px'}
          position="absolute"
          right="0px"
          top="95px"
          textAlign={'right'}
          style={{ margin: 0, padding: 0 }}>
          Higher
        </TextBlock>
      </HStack>
      <TextBlock fontSize="20px" lineHeight={'30px'}>
        This property offers a strong potential for growth in your investment while carrying significantly lower risk
        due to the absence of financial leverage. This adds additional stability and creates an opportunity for early
        return of capital if leverage is taken on later in the lifecycle of the investment.
      </TextBlock>
    </VStack>
  );
};
